import * as z from "zod";

export const updateShopPolicy = {
  name: "updateShopPolicy" as const,
  input: z.object({ body: z.string(), type: z.string() }),
  output: z.object({ success: z.boolean(), error: z.string().optional() }),
};
